import React, { lazy, Suspense } from 'react';

import PropTypes from 'prop-types';
//import { CSSTransitionGroup } from 'react-transition-group';
import { Switch, Route, withRouter, Redirect, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
//import { push } from 'connected-react-router'
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { FormattedMessage  } from 'react-intl';
//import isEqual from 'lodash.isequal';

import { GlobalConfigContext } from '../components/Config/GlobalConfigContext';

import logo from '../native_laboratoire_logo.svg';
import logowapp from '../wapp.svg';
import logoInverted from '../native_laboratoire_logo.svg';
import '../stylesheets/App.scss';
import '../stylesheets/App.forms.scss';

import {
    // CalendarOutlined,
    // DashboardOutlined,
    FileSyncOutlined,
    // LoadingOutlined,
    // UserOutlined,
    // SlackOutlined,
    // AndroidOutlined,
    // ContactsOutlined,
    // AimOutlined,
    // GlobalOutlined,
} from '@ant-design/icons';

import { Layout, BackTop, Spin, Button } from 'antd';
import Headroom from 'react-headroom';

/* General */
//import Profile from '../containers/profile/profile';
import Login from "../containers/login/Login";
import Reset from "../containers/login/Reset";
import NoMatch from '../components/NoMatch';
// import SearchWidget from '../components/Layout/SearchWidget';
import Navigation from '../components/Layout/Navigation';
import Notifications from '../components/Notifications';

import * as authActions from '../actions/auth';
import * as notificationActions from '../actions/notifications';
import { findRoute } from '../utilities/arrayUtils';
import cloneDeep from 'lodash.clonedeep';
import PrivateRoute from '../components/PrivateRoute';
import ProfileWidget from '../components/Layout/ProfileWidget';
import NotificationWidget from '../components/Layout/NotificationWidget';



const { Header, Content, Footer } = Layout;

const flattenRoutes = function(obj, context, allow_children = false) {
    const array = Array.isArray(obj) ? obj : [obj];
    return array.reduce(function(acc, value) {
        //console.log(`value:`, value)
        const valid = value.component && context.ability.can('navigate', value.key);
        // if(value.key === 'Service'){
        //     console.log(`valid:`, valid, value);
        //     console.log(`context.ability:`, context.ability.rules)
        // }
        if(valid || allow_children){
            acc.push(value);
        }
        if (value.children) {
            const allowChildren = valid && value.children.every(item => !item.navigation);

            acc = acc.concat(flattenRoutes(value.children, context, allowChildren));
            delete value.children;
        }
        return acc;
    }, []);
}

const Routing = React.memo(({ isAuthenticated, navigation }) => {
    //console.log(`Routing:`)
    const context = React.useContext(GlobalConfigContext);
    let history = useHistory();
    const routes = flattenRoutes(cloneDeep(navigation), context).filter(route => route.component)
    // const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    return (
        <Suspense fallback={<Spin /*indicator={antIcon}*/ className="content-loading" />}>
            <Switch>
                <Route path="/login" component={Login} />
                {
                    routes.map((route, i) => {
                        return <PrivateRoute isAuthenticated={isAuthenticated} key={(route.key)?route.key:route.url} path={route.url} component={route.component} exact={route.exact?route.exact:false} breadcrumb={findRoute(navigation, route.url)} />
                    })
                }
                <PrivateRoute isAuthenticated={isAuthenticated} component={NoMatch} history={history}/>
            </Switch>
        </Suspense>
    )
})

class App extends React.PureComponent {
	constructor(props, context) {
        const trainers_menu_accessed_by = (context.user && context.user.role == 'trainer' && context.user.is_master_trainer)?['admin', 'manager', 'trainer','marketer']:['admin', 'manager','marketer'];
        const reviews_menu_accessed_by = (context.user && context.user.role == 'trainer')?['admin', 'manager', 'beauty_advisor','representative', 'trainer','marketer']:['admin', 'manager', 'beauty_advisor','representative','marketer'];
        const managerType = context.user && (context.user.type || context.user.manager_type);
        const incidents_menu_accessed_by = (context.user && context.user.role === 'manager' && (managerType === 'area' || managerType === 'sales'))
            ? ['admin']
            : ['admin', 'manager'];
  		super(props);
        const dashboardText = (context.user && context.user.role == 'agency')?<FormattedMessage id="menu.dashboard" defaultMessage={`Ημερολόγιο`} />:<FormattedMessage id="menu.dashboard" defaultMessage={`Επισκόπηση`} />
		  
		this.navigation = [
			{
			  name: dashboardText,
			  url: '/',
			  key: 'Dashboard',
			//   icon: <DashboardOutlined />,
              disabled: false,
			  isPrimary: true,
			  exact: true,
              roles: ['admin', 'manager', 'representative', 'beauty_advisor','trainer','agency','secretary','marketer'],
              component: lazy(() => import('./home')),
			},

            // { 
            //     name: <FormattedMessage id="menu.calendar.calendar" defaultMessage={'Ημερολόγιο'}  />,
            //     url: '/calendar/', 
            //     key: 'Calendar',
            //     // icon: <CalendarOutlined />,
            //     disabled: false,
            //     isPrimary: true,
            //     exact: true,
            //     roles: ['admin', 'manager', 'representative', 'beauty_advisor','secretary','trainer'],
            //     // component: Calendar,
            //     component: lazy(() => import('./calendar')),
                
            // },

            { 
                name: <FormattedMessage id="menu.calendar.calendar" defaultMessage={'Ειδοποιήσεις'}  />,
                url: '/notifications/home', 
                key: 'Notif',
                // icon: <CalendarOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: [],
                // component: Calendar,
                component: lazy(() => import('./notifications')),
                children: [{ 
                    url:'/notifications/:number',
                    roles: [],
                    // component:TrainerNew,
                    component:lazy(() => import('./notifications/new')),
                    navigation:false
                }]
                
            },

            

            { 
                name: <FormattedMessage id="menu.reservations.reservations" defaultMessage={'Προγράμματα'}  />,
                url: '/reservations/home', 
                key: 'Reservation',
                // icon: <CalendarOutlined />,
                // disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager', 'representative', 'beauty_advisor','trainer','agency','secretary','marketer'],
                // component: Reservation,
                component: lazy(() => import('./reservations')),
                
                children: [
                    
                    { 
                        name: <FormattedMessage id="menu.calendar.calendar" defaultMessage={'Ημερολόγιο Προγραμμάτων'}  />,
                        url: '/calendar/', 
                        key: 'Calendar',
                        // icon: <CalendarOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager', 'representative', 'beauty_advisor','secretary','trainer','marketer'],
                        // component: Calendar,
                        component: lazy(() => import('./calendar')),
                    },
                    { 
                        name: <FormattedMessage id="menu.calendar.calendar" defaultMessage={'Λίστα Προγραμμάτων'}  />,
                        url: '/reservations/home', 
                        key: 'Reservation',
                        // icon: <CalendarOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager', 'representative', 'beauty_advisor','trainer','agency','secretary','marketer'],
                        // component: Calendar,
                        component: lazy(() => import('./reservations')),
                    },
                    { 
                        url:'/reservations/:number',
                        // component:ReservationNew,
                        component:lazy(() => import('./reservations/new')),
                        navigation:false
                    }
                ]
            },
            { 
                name: <FormattedMessage id="menu.pharmacies.pharmacies" defaultMessage={'Φαρμακεία'} />,
                url: '/pharmacies/home', 
                key: 'Pharmacy',
                // icon: <SlackOutlined />,
                // disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager','representative','trainer','secretary','marketer'],
                // component:Pharmacy,
                component: lazy(() => import('./pharmacies')),
                children: [
                    { 
                        name: <FormattedMessage id="menu.pharmacies.pharmacies" defaultMessage={'Λίστα Φαρμακείων'} />,
                        url: '/pharmacies/home', 
                        key: 'Pharmacy',
                        // icon: <SlackOutlined />,
                        // disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager','representative','trainer','secretary','marketer'],
                        // component:Pharmacy,
                        component: lazy(() => import('./pharmacies')),
                        
                    },
                    { 
                        name: <FormattedMessage id="menu.map.map" defaultMessage={'Χάρτης Φαρμακείων'}  />,
                        url: '/map/', 
                        key: 'MapPage',
                        // icon: <CalendarOutlined />,
                        // disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['manager','representative', 'trainer','admin','secretary','marketer'],
                        // component: MapPage,
                        component: lazy(() => import('./map')),
                        
                    },
                    { 
                    url:'/pharmacies/:number',
                    roles: ['admin', 'manager','marketer'],
                    // component:PharmacyNew,
                    component:lazy(() => import('./pharmacies/new')),
                    navigation:false
                }]
            },
            { 
                name: <FormattedMessage id="menu.leaves_of_absense.leaves_of_absense" defaultMessage={'Άδειες'}  />,
                url: '/leaves_of_absense_calendar/home', 
                key: 'LeaveOfAbsenseCalendar',
                // icon: <GlobalOutlined />,
                disabled: false,
                isPrimary: false,
                exact: true,
                roles: ['beauty_advisor','agency'],
                // component:LeaveOfAbsenseCalendar,
                component: lazy(() => import('./leaves_of_absense_calendar')),
            },

            {
                name: <FormattedMessage id="menu.representatives.representatives" defaultMessage={'REPs'} />,
                url: '/representatives/home', 
                key: 'representative',
                // icon: <AndroidOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager','trainer','secretary','beauty_advisor','marketer','representative'],
                // component:Representative,
                component: lazy(() => import('./representatives')),
                    children: [{ 
                    url:'/representatives/:number',
                    roles: ['admin', 'manager','marketer'],
                    // component:RepresentativeNew,
                    component:lazy(() => import('./representatives/new')),
                    navigation:false
                }]
            },
            { 
                name: <FormattedMessage id="menu.beauty_advisors.beauty_advisors" defaultMessage={'BAs'} />,
                url: '/beauty_advisors/home', 
                key: 'BeautyAdvisor',
                // icon: <ContactsOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager','trainer','agency','secretary','marketer'],
                // component:BeautyAdvisor,
                component: lazy(() => import('./beauty_advisors')),
                children: [{ 
                    url:'/beauty_advisors/:number',
                    roles: ['admin', 'manager','marketer'],
                    // component:BeautyAdvisorNew,
                    component:lazy(() => import('./beauty_advisors/new')),
                    navigation:false
                }]
            },
           
            // { 
            //     name: <FormattedMessage id="menu.seminar_requests.seminar_requests" defaultMessage={'Σεμινάρια'} />,
            //     url: '/seminar_requests/home', 
            //     key: 'SeminarRequest',
            //     // icon: <ContactsOutlined />,
            //     disabled: false,
            //     isPrimary: true,
            //     exact: true,
            //     roles: ['admin', 'manager','trainer'],
            //     // component:Trainer,
            //     component: lazy(() => import('./seminar_requests')),
            //     children: [{ 
            //         url:'/seminar_requests/:number',
            //         roles: ['admin', 'manager','trainer'],
            //         // component:TrainerNew,
            //         component:lazy(() => import('./seminar_requests/new')),
            //         navigation:false
            //     }]
            // },

            { 
                name: <FormattedMessage id="menu.trainers.field_trainers" defaultMessage={'Field & Training'} />,
                url: '#', 
                key: 'Trainer',
                // icon: <ContactsOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: trainers_menu_accessed_by,
                // component:Trainer,
                // component: lazy(() => import('./trainers/home')),
                children: [
                    { 
                        name: <FormattedMessage id="menu.trainings.trainers" defaultMessage={'Εκπαιδευτές'} />,
                        url: '/trainers/home', 
                        key: 'Trainers',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        navigation: true,
                        isPrimary: true,
                        exact: true,
                        roles: trainers_menu_accessed_by,
                        // component:Trainer,
                        component: lazy(() => import('./trainers/index')),
                        
                    },
                    {
                        name: <FormattedMessage id="menu.trainers.field_officers" defaultMessage={'Field S.O. Officers'} />,
                        url: '/field_officers/home',
                        key: 'FieldOfficers',
                        disabled: false,
                        navigation: true,
                        isPrimary: true,
                        exact: false,
                        roles: trainers_menu_accessed_by,
                        component: lazy(() => import('./field_officers/index')),
                    },
                    // {
                    //     name: <FormattedMessage id="menu.trainings.activations" defaultMessage={'Activations'} />,
                    //     url: '/activations/home',
                    //     key: 'Activations',
                    //     disabled: false,
                    //     navigation: true,
                    //     isPrimary: true,
                    //     exact: true,
                    //     roles: trainers_menu_accessed_by,
                    //     component: lazy(() => import('./activations/index')),
                    // },
                    { 
                        url:'/trainers/:number',
                        roles: ['admin', 'manager','trainer','marketer'],
                        // component:TrainerNew,
                        component:lazy(() => import('./trainers/new')),
                        navigation:false
                    },
                    
                ]
            },

            { 
                name: <FormattedMessage id="menu.trainings.trainings_and_activations" defaultMessage={'Field & Training Agenda'}  />,
                url: '#', 
                key: 'Trainings',
                // icon: <CalendarOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager','representative','trainer','beauty_advisor','secretary','marketer'],
                children: [
                    
                    { 
                        name: <FormattedMessage id="menu.trainings.trainings_calendar" defaultMessage={'Ημερολόγιο Εκπαιδεύσεων'} />,
                        url: '/trainings_calendar/', 
                        key: 'TrainingCalendar',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager','trainer','representative','beauty_advisor','marketer'],
                        // component:Trainer,
                        component: lazy(() => import('./trainings_calendar')),
                        
                    },
                    { 
                        name: <FormattedMessage id="menu.trainings.activations_calendar" defaultMessage={'Ημερολόγιο Field S.O.'} />,
                        url: '/activations_calendar/', 
                        key: 'ActivationsCalendar',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager','trainer','representative','beauty_advisor','marketer'],
                        // component:Trainer,
                        component: lazy(() => import('./activations_calendar')),
                        
                    },
                    { 
                        name: <FormattedMessage id="menu.trainings.trainings" defaultMessage={'Λίστα Εκπαιδεύσεων'} />,
                        url: '/trainings/home', 
                        key: 'Training',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager','trainer','representative','beauty_advisor','secretary','marketer'],
                        // component:Trainer,
                        component: lazy(() => import('./trainings')),
                        children: [{ 
                            url:'/trainings/:number',
                            roles: ['admin', 'manager','trainer','representative','beauty_advisor','secretary','marketer'],
                            // component:TrainerNew,
                            component:lazy(() => import('./trainings/new')),
                            navigation:false
                        }]
                    },

                    { 
                        name: <FormattedMessage id="menu.trainings.activations" defaultMessage={'Λίστα Field S.O.'} />,
                        url: '/activations/home', 
                        key: 'Activations',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager','trainer','representative','beauty_advisor','secretary','marketer'],
                        // component:Trainer,
                        component: lazy(() => import('./activations')),
                        children: [{ 
                            url:'/activations/:number',
                            roles: ['admin', 'manager','trainer','representative','beauty_advisor','secretary','marketer'],
                            // component:TrainerNew,
                            component:lazy(() => import('./activations/new')),
                            navigation:false
                        }]
                    },

                   
                    
                    { 
                        name: <FormattedMessage id="menu.trainings.trainee" defaultMessage={'Λίστα Εκπαιδευομένων'} />,
                        url: '/trainees/home', 
                        key: 'Trainee',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['manager','trainer'],
                        // component:Trainer,
                        component: lazy(() => import('./trainees')),
                        children: [{ 
                            url:'/trainees/:number',
                            roles: ['manager','trainer'],
                            // component:TrainerNew,
                            component:lazy(() => import('./trainees/new')),
                            navigation:false
                        }]
                    },
                ]
            },
            
            { 
                name: <FormattedMessage id="menu.reviews.reviews" defaultMessage={'Αξιολογήσεις'} />,
                url: '/reservation_ba_reviews/home', 
                key: 'ReservationBaReviews',
                // icon: <ContactsOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['beauty_advisor'],
                // component:Trainer,
                component: lazy(() => import('./reservation_ba_reviews')),
                children: [{ 
                    url:'/reservation_ba_reviews/:number',
                    roles: ['beauty_advisor'],
                    // component:TrainerNew,
                    component:lazy(() => import('./reservation_ba_reviews/new')),
                    navigation:false
                }]
            },
            // { 
            //     name: <FormattedMessage id="menu.reviews.reviews" defaultMessage={'Αξιολογήσεις'} />,
            //     url: '/reservation_rep_reviews/home', 
            //     key: 'ReservationRepReviews',
            //     // icon: <ContactsOutlined />,
            //     disabled: false,
            //     isPrimary: true,
            //     exact: true,
            //     roles: ['representative'],
            //     // component:Trainer,
            //     component: lazy(() => import('./reservation_rep_reviews')),
            //     children: [{ 
            //         url:'/reservation_rep_reviews/:number',
            //         roles: ['representative'],
            //         // component:TrainerNew,
            //         component:lazy(() => import('./reservation_rep_reviews/new')),
            //         navigation:false
            //     }]
            // },

            { 
                name: <FormattedMessage id="menu.reviews.reviews" defaultMessage={'Αξιολογήσεις '}  />,
                url: '#', 
                key: 'Reviews',
                // icon: <CalendarOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager','representative','trainer','marketer'],
                children: [

                    { 
                        name: <FormattedMessage id="menu.reservation_reviews.reservation_ba_reviews" defaultMessage={'Αξιολογήσεις Αισθητικών'} />,
                        url: '/reservation_ba_reviews/home', 
                        key: 'ReservationBaReviews',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: reviews_menu_accessed_by,
                        // component:ReservationReviews,
                        component: lazy(() => import('./reservation_ba_reviews')),
                        children: [                    { 
                            url:'/reservation_ba_reviews/:number',
                            // component:ReservationReviewNew,
                            component:lazy(() => import('./reservation_ba_reviews/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.reservation_reviews.reservation_rep_reviews" defaultMessage={'Αξιολογήσεις Πωλητών'} />,
                        url: '/reservation_rep_reviews/home', 
                        key: 'ReservationRepReviews',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: reviews_menu_accessed_by,
                        // component:ReservationReviews,
                        component: lazy(() => import('./reservation_rep_reviews')),
                        children: [                    { 
                            url:'/reservation_rep_reviews/:number',
                            // component:ReservationReviewNew,
                            component:lazy(() => import('./reservation_rep_reviews/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.trainings.training_reviews" defaultMessage={'Αξιολογήσεις Εκπαιδεύσεων'} />,
                        url: '/training_reviews/home', 
                        key: 'TrainingReview',
                        // icon: <ContactsOutlined />,
                        disabled: false,
                        isPrimary: true,
                        exact: true,
                        roles: ['admin', 'manager','trainer','representative','beauty_advisor','marketer'],
                        // component:Trainer,
                        component: lazy(() => import('./training_reviews')),
                        children: [{ 
                            url:'/training_reviews/:number',
                            roles: ['admin', 'manager','trainer','representative','beauty_advisor','marketer'],
                            // component:TrainerNew,
                            component:lazy(() => import('./training_reviews/new')),
                            navigation:false
                        }]
                    },
                ]
            },
            { 
                name: <FormattedMessage id="menu.incidents.incidents" defaultMessage={'Συμβάντα'} />,
                url: '/incidents/home', 
                key: 'Incidents',
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: incidents_menu_accessed_by,
                // component:Incident,
                component: lazy(() => import('./incidents')),
                children: [                    { 
                    url:'/incidents/:number',
                    // component:IncidentNew,
                    component:lazy(() => import('./incidents/new')),
                    navigation:false
                }]
            },
            { 
                name: <FormattedMessage id="menu.settings.settings" defaultMessage={'Ρυθμίσεις'}  />,
                url: '#', 
                key: 'Settings',
                // icon: <CalendarOutlined />,
                disabled: false,
                isPrimary: true,
                exact: true,
                roles: ['admin', 'manager'],
                // component:Reservation,
                // component: lazy(() => import('./users')),
                children: [

                    { 
                        name: <FormattedMessage id="menu.regions.regions" defaultMessage={'Περιοχές'} />,
                        url: '/regions/home', 
                        key: 'Region',
                        // icon: <AimOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component:Region,
                        component: lazy(() => import('./regions')),
                        children: [{ 
                            url:'/regions/:number',
                            roles: ['admin', 'manager'],
                            // component:RegionNew,
                            component:lazy(() => import('./regions/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.subregions.subregions" defaultMessage={'Πόλεις'} />,
                        url: '/subregions/home', 
                        key: 'Subregion',
                        // icon: <GlobalOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component:Subregion,
                        component: lazy(() => import('./subregions')),
                        children: [{ 
                            url:'/subregions/:number',
                            roles: ['admin', 'manager'],
                            // component:SubregionNew,
                            component:lazy(() => import('./subregions/new')),
                            navigation:false
                        }]
                    },
                    // { 
                    //     name: <FormattedMessage id="menu.leaves_of_absense.leaves_of_absense" defaultMessage={'Άδειες'}  />,
                    //     url: '/leaves_of_absense/home', 
                    //     key: 'LeaveOfAbsense',
                    //     // icon: <GlobalOutlined />,
                    //     disabled: false,
                    //     isPrimary: false,
                    //     exact: true,
                    //     roles: ['admin', 'manager'],
                    //     // component:LeaveOfAbsense,
                    //     component: lazy(() => import('./leaves_of_absense')),
                    //     children: [{ 
                    //         url:'/leaves_of_absense/:number',
                    //         roles: ['admin', 'manager'],
                    //         // component:LeaveOfAbsenseNew,
                    //         component:lazy(() => import('./leaves_of_absense/new')),
                    //         navigation:false
                    //     }]
                    // },
                    { 
                        name: <FormattedMessage id="menu.holidays.holidays" defaultMessage={'Αργίες'}  />,
                        url: '/holidays/home', 
                        key: 'Holiday',
                        // icon: <GlobalOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component: Holiday ,
                        component: lazy(() => import('./holidays')),
                        children: [{ 
                            url:'/holidays/:number',
                            roles: ['admin', 'manager'],
                            // component:HolidayNew,
                            component:lazy(() => import('./holidays/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.users.users" defaultMessage={'Χρήστες'} />,
                        url: '/users/home', 
                        key: 'User',
                        // icon: <UserOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: [],
                        // component:User,
                        component: lazy(() => import('./users')),
                        children: [{ 
                            url:'/users/:number',
                            roles: [],
                            // component:UserNew,
                            component:lazy(() => import('./users/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.users.users" defaultMessage={'Managers'} />,
                        url: '/managers/home', 
                        key: 'Manager',
                        // icon: <UserOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['manager'],
                        // component:Manager,
                        component: lazy(() => import('./managers')),
                        // children: [{ 
                        //     url:'/managers/:number',
                        //     roles: [],
                        //     component:ManagerNew,
                        //     //component:lazy(() => import('./beauty_advisors/new')),
                        //     navigation:false
                        // }]
                    },
                    { 
                        name: <FormattedMessage id="menu.admins.admins" defaultMessage={'Admins'} />,
                        url: '/admins/home', 
                        key: 'Admin',
                        // icon: <UserOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['manager'],
                        // component:Admin,
                        component: lazy(() => import('./admins')),
                        // children: [{ 
                        //     url:'/admins/:number',
                        //     roles: [],
                        //     component:AdminNew,
                        //     //component:lazy(() => import('./beauty_advisors/new')),
                        //     navigation:false
                        // }]
                    },
                    { 
                        name: <FormattedMessage id="menu.agencies.users" defaultMessage={'Agencies'} />,
                        url: '/agencies/home', 
                        key: 'Agency',
                        // icon: <UserOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['manager', 'admin'],
                        // component:Manager,
                        component: lazy(() => import('./agencies')),
                    },
                    { 
                        name: <FormattedMessage id="menu.secretaries.users" defaultMessage={'Secretaries'} />,
                        url: '/secretaries/home', 
                        key: 'Secretary',
                        // icon: <UserOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['manager', 'admin'],
                        // component:Manager,
                        component: lazy(() => import('./secretaries')),
                    },
                    { 
                        name: <FormattedMessage id="menu.marketers.users" defaultMessage={'Marketing'} />,
                        url: '/marketers/home', 
                        key: 'Marketer',
                        // icon: <UserOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['manager', 'admin'],
                        // component:Manager,
                        component: lazy(() => import('./marketers')),
                    },
                    // { 
                    //     name: <FormattedMessage id="menu.trainers.trainers" defaultMessage={'Trainers'} />,
                    //     url: '/trainers/home', 
                    //     key: 'Trainer',
                    //     // icon: <ContactsOutlined />,
                    //     disabled: false,
                    //     isPrimary: false,
                    //     exact: true,
                    //     roles: ['manager'],
                    //     component:Trainer,
                    //     // component: lazy(() => import('./users')),
                    //     // children: [{ 
                    //     //     url:'/trainers/:number',
                    //     //     roles: ['admin', 'manager','trainer'],
                    //     //     component:TrainerNew,
                    //     //     // component:lazy(() => import('./beauty_advisors/new')),
                    //     //     navigation:false
                    //     // }]
                    // },
                    { 
                        name: <FormattedMessage id="menu.seasons.seasons" defaultMessage={'Seasons'} />,
                        url: '/seasons/home', 
                        key: 'Season',
                        // icon: <AimOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component:Season,
                        component: lazy(() => import('./seasons')),
                        children: [{ 
                            url:'/seasons/:number',
                            roles: ['admin', 'manager'],
                            // component:SeasonNew,
                            component:lazy(() => import('./seasons/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.pharmacy_groups.pharmacy_groups" defaultMessage={'Ομάδες Φαρμακείων'} />,
                        url: '/pharmacy_groups/home', 
                        key: 'PharmacyGroup',
                        // icon: <AimOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component:PharmacyGroup,
                        component: lazy(() => import('./pharmacy_groups')),
                        children: [{ 
                            url:'/pharmacy_groups/:number',
                            roles: ['admin', 'manager'],
                            // component:PharmacyGroupNew,
                            component:lazy(() => import('./pharmacy_groups/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.grand_magazia.grand_magazia" defaultMessage={'Όμιλοι Καταστημάτων'} />,
                        url: '/grand_magazia/home', 
                        key: 'GrandMagazia',
                        // icon: <AimOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component:GrandMagazia,
                        component: lazy(() => import('./grand_magazia')),
                        children: [{ 
                            url:'/grand_magazia/:number',
                            roles: ['admin', 'manager'],
                            // component:GrandMagaziaNew,
                            component:lazy(() => import('./grand_magazia/new')),
                            navigation:false
                        }]
                    },
                    { 
                        name: <FormattedMessage id="menu.general_settings" defaultMessage={'Γενικές Ρυθμίσεις'} />,
                        url: '/general_settings/', 
                        key: 'GeneralSettings',
                        // icon: <AimOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager'],
                        // component:GrandMagazia,
                        component: lazy(() => import('./general_settings')),
                        
                    },

                    { 
                        name: <FormattedMessage id="menu.training_notification_rules" defaultMessage={'Ενημερώσεις εκπαιδέυσεων'} />,
                        url: '/training_notification_rules/home', 
                        key: 'TrainingNotificationRules',
                        // icon: <AimOutlined />,
                        disabled: false,
                        isPrimary: false,
                        exact: true,
                        roles: ['admin', 'manager','trainer'],
                        // component:GrandMagazia,
                        component: lazy(() => import('./training_notification_rules')),
                        
                    },


                ]
            }
        ];
        this.state = {
            setupCurrent: undefined,
		}
  	}
    reload = () => {
        window.location.reload(true);
    }
  	componentDidMount = () => {
  	    //console.log(`App componentDidMount:`);

        window && window.isUpdateAvailable && window.isUpdateAvailable.then(isAvailable => {
            //console.log(`isUpdateAvailable:`, isAvailable);
            if (isAvailable) {
                this.context.notifications.notify({
                    title: this.context.intl.formatMessage({ id: 'app.notification.update.title', defaultMessage: 'New update is available!' }),
                    message: <FormattedMessage id="app.notification.update.message" defaultMessage={'Please refresh to apply the latest update.'} />,
                    type: 'notification',
                    kind: 'info',
                    options: {
                        duration: 0,
                        btn: <Button onClick={this.reload} ><FormattedMessage id="app.notification.update.button" defaultMessage={'Refresh'} /></Button>,
                        icon: <FileSyncOutlined style={{ color:'#0000FF' }} />
                    }
                });
            }
        })
    
        const { socket } = this.context;
		if(socket){
			socket.on('notifications', this.applyNotification);
			//socket.on('property', this.setActiveProperty);
		}
    }
	componentWillUnmount(){
		const { socket } = this.context;
		if(socket){
			socket.off('notifications', this.applyNotification);
			//socket.off('property', this.setActiveProperty);
		}
    }
	applyNotification = (data) => {
		//console.log('applyNotification', data);
		
		if(data.action && data.action === 'dismiss' && data.id !== undefined){
			this.props.notificationActions.notifyDismiss(data.id);
			this.props.notificationActions.notify(data);
		}else{
			this.props.notificationActions.notify(data);
		}
	}
	state = {
        redirectToReferrer: false
    }
	render() {
		const { from } = this.props.location.state || { from: { pathname: '/' } }
		const { redirectToReferrer } = this.state;
        const { sider_position, sticky_top, theme, isMobile, isTablet, user } = this.context;
        //console.log(`activeProperty:`, activeProperty)
        
        const { isAuthenticated } = this.props;
		
		if(!isAuthenticated){
            switch(this.props.location.pathname){
                case '/users/reset':
                    return(<Reset />);
                default:
                    return (<Login />)
            }
			
		}
		
		if (redirectToReferrer) {
			return (
				<Redirect to={from}/>
			)
		}
        document.documentElement.setAttribute('data-theme', theme);
        
        // const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

		return (
            <span >
            <Headroom disable={!sticky_top}>								
                <Header id="header">
                <div className='main-layout-container'>
                    <span className="header-logo">
                        {((sider_position === 'top') || (isMobile || isTablet) ) && <Navigation menu={this.navigation} displayHamburger={true} history={this.props.history}/> }
                        <div className="logo">
                            <Link to={`/`} onClick={this.closeDrawer}><img src={theme === 'dark' ? logoInverted : logo} alt="Logo" /></Link>
                        </div>	
                    </span>
                    {/*<Col xs={24} sm={12} md={17} lg={16} xl={13} className="text-center-">
                        <SearchWidget />
                    </Col>*/}
                    <span className="header-options">
                        {/* {(ability.can('list:search', 'Reservation') || ability.can('list:search', 'Contact')) && <SearchWidget />} */}
                        {/* {!isMobile && !isTablet && ability.can('navigate', 'Calendar') && <span className="calendar-widget"><Tooltip placement="bottomRight" title={<FormattedMessage id="menu.calendar" defaultMessage={`Calendar`} />}><Link to={'/calendar/home'} alt="Calendar" ><ScheduleOutlined /></Link></Tooltip></span>} */}
                        { ((sider_position !== 'top') && !isMobile) && <Navigation menu={this.navigation} /> }
                        
                        {user && user.role!='marketer' &&
                            <NotificationWidget />
                        }
                        <ProfileWidget onLogout={this.handleLogout} />
                        
                    </span>
                    </div>
                </Header>
            </Headroom>
            <Layout id="layout-container">
                
                {/* { ((sider_position !== 'top') && !isMobile) && <Navigation menu={this.navigation} /> } */}
                <div className='row_purple'></div>
                <Layout className={`main-wrapper ${(this.props.location.pathname === '/')?'dashboard-wrapper--':''}`}>
                    <div className='main-layout-container'>
                    <Content className="main-layout">
                        <Notifications />
                        <BackTop />
                        {/* <Suspense fallback={<Spin indicator={antIcon} className="content-loading" />}> */}
                            <Routing navigation={this.navigation} isAuthenticated={isAuthenticated} />
                        {/* </Suspense> */}
                    </Content>
                    </div>
                </Layout>
            </Layout>
            <Footer className="login-footer">
                <div className='main-layout-container footer-flex'>
                    <p>Native Laboratoire Beauty Advisors Portal @ {new Date().getFullYear()}. All rights reserved.</p>
                    <span className="footer-logo">
                        <Link to={`/`} onClick={this.closeDrawer}><img src={logowapp} alt="Wapp Development" /></Link>
                    </span>
                </div>
            </Footer>
            </span>
        );
	}
}

App.propTypes = {
	dispatch: PropTypes.func.isRequired,
	authActions: PropTypes.any,
	history: PropTypes.object,
	setupCurrent: PropTypes.number
};

App.contextType = GlobalConfigContext;

const mapStateToProps = state => {
	//const { auth } = state;
	
	return {
		isAuthenticated: state.auth.isAuthenticated,
		// activeProperty: state.auth.activeProperty,
		setupCurrent: state.auth.setupCurrent,
	};
};

const mapDispatchToProps = dispatch => ({
	authActions: bindActionCreators(authActions, dispatch),
	notificationActions: bindActionCreators(notificationActions, dispatch),
	dispatch
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));